<nav class="clug-topbar d-none d-lg-flex" id="topbar">
  <div class="topbar-inner">

    <!-- Create button + shortcuts menu -->
    <div class="topbar-create">
      <button type="button" [matMenuTriggerFor]="aboveMenu" class="btn-create">
        <i class="bi bi-plus-circle-dotted"></i>
        <span>Create</span>
        <i class="bi bi-chevron-down chev"></i>
      </button>
      <mat-menu #aboveMenu="matMenu" class="clug-shortcuts-menu" xPosition="after" yPosition="below">
        <button class="shortcut-item"
          *ngFor="let shortcut of shortcuts"
          [style.display]="user?.role_uuid === shortcut.role ? '' : 'none'"
          (click)="onAdd(shortcut)">
          <span class="ico" [style.background]="shortcut.bgColor">
            <i [class]="shortcut.icon" [style.color]="shortcut.color"></i>
          </span>
          <span class="label">{{ shortcut.name }}</span>
        </button>
      </mat-menu>
    </div>

    <!-- Search -->
    <form class="topbar-search ms-auto" (submit)="$event.preventDefault()">
      <i class="bi bi-search"></i>
      <input type="text" placeholder="Search" aria-label="Search" />
    </form>

    <!-- Right actions -->
    <div class="topbar-actions">
      <button type="button"
        class="icon-btn"
        [matMenuTriggerFor]="notificationPenal"
        (click)="showDropDown = false; readAllNotifications()"
        title="Notifications"
        aria-label="Notifications">
        <i class="bi bi-bell"></i>
        <span class="dot" *ngIf="newNotificationStatus"></span>
      </button>

      <mat-menu #notificationPenal="matMenu" id="menu" class="notificationPanel" [hasBackdrop]="false">
        <app-notification-panel
          [notifications]="bellNotificationData"
          [notificationCurrentPage]="notificationCurrentPage"
          [notificationLastPage]="notificationLastPage"></app-notification-panel>
      </mat-menu>

      <!-- Profile -->
      <div class="me-wrap" #meWrap>
        <button type="button" class="me" (click)="showDropDown = !showDropDown" aria-haspopup="true" [attr.aria-expanded]="showDropDown">
          <span class="avatar" *ngIf="dataSharedService.profileImage">
            <img alt="" [src]="dataSharedService.profileImage" />
          </span>
          <span class="avatar avatar-initials" *ngIf="!dataSharedService.profileImage">
            {{ authService.getInitials(user.name) }}
          </span>
          <span class="me-text">
            <span class="name">{{ user.name }}</span>
            <span class="role" *ngIf="profileSubtitle">{{ profileSubtitle }}</span>
          </span>
          <i class="bi bi-chevron-down chev"></i>
        </button>

        <div class="me-dropdown" *ngIf="showDropDown">
          <div class="me-dropdown-head">
            <span class="avatar avatar-lg" *ngIf="dataSharedService.profileImage">
              <img alt="" [src]="dataSharedService.profileImage" />
            </span>
            <span class="avatar avatar-lg avatar-initials" *ngIf="!dataSharedService.profileImage">
              {{ authService.getInitials(user.name) }}
            </span>
            <span class="head-text">
              <span class="name">{{ user.name }}</span>
              <span class="email" *ngIf="user.email">{{ user.email }}</span>
              <span class="role-pill">{{ roleLabel }}</span>
            </span>
          </div>
          <div class="me-divider"></div>
          <a class="me-item" href="/dashboard">
            <i class="bi bi-house"></i><span>Home</span>
          </a>
          <a class="me-item" href="/settings">
            <i class="bi bi-gear"></i><span>Settings</span>
          </a>
          <div class="me-divider"></div>
          <a class="me-item danger" routerLink="/logout">
            <i class="bi bi-box-arrow-right"></i><span>Logout</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</nav>
